import { create } from "zustand";
import { getAuthUser } from "../helpers";

interface State {
  token: string;
  userData: {
    email: string;
    first_name: string;
    last_name: string;
    role: {
      id: number;
      name: string;
    };
    role_id: number;
  };
}

interface Action {
  updateToken: (token: State["token"]) => void;
  updateUserData: (userData: State["userData"]) => void;
}

export const useUserStore = create<State & Action>((set) => ({
  token: "",
  userData: getAuthUser(),
  updateToken: (token) => set(() => ({ token: token })),
  updateUserData: (userData) => set(() => ({ userData: userData })),
}));
